import React from 'react';
import useIsMobile from '../hooks/useIsMobile';
import MainLayout from './MainLayout';
import MobileLayout from '../mobile/MobileLayout';

/**
 * Top-level shell switch. On phones (< md) we render the purpose-built
 * native-app shell; on tablet/desktop the original MainLayout is untouched.
 * Both render the routed <Outlet />, so this is a pure presentation swap.
 */
export default function ResponsiveLayout() {
  const isMobile = useIsMobile();
  return isMobile ? <MobileLayout /> : <MainLayout />;
}
